<template>
  <div id="mapp" class="mapp">
    <router-view/>
  </div>
</template>

<style>
  .mapp{background: #f7f7f7;height: 100%;}

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: rgba(255,255,255,.1);
  }
  ::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, .30); border-radius: 50px; }
  ::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, .40); }
</style>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'app',
  methods: {
    ...mapMutations('cashier/layout', [
      'setDevice'
    ]),
    handleWindowResize () {
     this.handleMatchMedia();
    },
    handleMatchMedia () {
      const matchMedia = window.matchMedia;
      if (matchMedia('(max-width: 600px)').matches) {
        this.setDevice('Mobile');
      } else if (matchMedia('(max-width: 992px)').matches) {
        this.setDevice('Tablet');
      } else {
        this.setDevice('Desktop');
      }
      this.$bus.emit('resize',{h:document.body.clientHeight,w:document.body.clientWidth});
    }
  },
  mounted () {
    if (window.addEventListener) {
      window.addEventListener("resize", ()=> {
        this.handleWindowResize();
      });
    } else if (window.attachEvent) {
      window.attachEvent("onresize",  ()=> {
        this.handleWindowResize();
      });
    }

    setTimeout(()=>{
      this.handleWindowResize();
    },500);
  },
  beforeDestroy () {

  }
}
</script>
